import './styles.scss';
import { UiTooltip } from 'shared/uikit';
import { getMonthName } from 'shared/constants/MONTHS';
import { formatValueWithUnits } from 'pages/profile-dashboard/utilities/formatValueWithUnits';
import cn from 'classnames';
import { useDashboardDict } from 'pages/profile-dashboard/context/useDashboardDict';
import { IStatisticItem } from 'shared/models/UserDashboardModel';

interface PropertiesBadgeProps {
    statistic: IStatisticItem[];
    label_full?: string;
    label_short?: string;
    className?: string;
    zIndexTooltip?: number
}

const capitalizeFirstLetter = (text: string) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export const PPDWidgetPropertiesBadge = ({
    statistic,
    label_full = "Статистика общего прироста",
    label_short = "Статистика",
    className,
    zIndexTooltip
}: PropertiesBadgeProps) => {
    const { units } = useDashboardDict();

    const renderTooltip = () => {
        return (
            <div className="ppd-widget-properties-badge__content">
                <h5 className="ppd-widget-properties-badge__title">
                    {label_full}
                </h5>
                <ul className="ppd-widget-properties-badge__list">
                    {statistic.map((item, index) => (
                        <li key={index} className="ppd-widget-properties-badge__item">
                            {item.month && capitalizeFirstLetter(getMonthName(item.month))} {item.year}:
                            <span className="ppd-widget-properties-badge__value">
                                {formatValueWithUnits(
                                    { amount: item.amount, unit_id: item.unit_id },
                                    units,
                                )}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    return (
        <div className={cn('ppd-widget-properties-badge', className )}>
            <UiTooltip
                content={renderTooltip()}
                position="top"
                delay={300}
                maxWidth={'max-content'}
                zIndex={zIndexTooltip}
                contentClassName={"ppd-widget-properties-badge__tooltip-content"}
            >
                <button
                    className="ppd-widget-properties-badge__trigger"
                    type="button"
                >
                    {label_short}
                </button>
            </UiTooltip>
        </div>
    );
};
